import React, { useState, useCallback } from 'react';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ReplayIcon from '@mui/icons-material/Replay';
import Typography from '@mui/material/Typography';
import UploadDoc from './UploadDocCompare';
import { StyledTab, StyledTabs } from './StyledTabs';

const TextFieldToCompare = ({ tabName, value, onChange, onClear, id, error, CurrentScan }) => {
    const [tabValue, setTabValue] = useState(0);
    const [uploadCompleted, setUploadCompleted] = useState(false);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleFileUpload = (fileText) => {
        onChange({ target: { value: fileText } });
    };

    const handleClearText = () => {
        onChange({ target: { value: '' } });
        onClear();
        setUploadCompleted(false);
    };

    const switchToTextTab = () => {
        setTabValue(0);
    };

    const onUploadComplete = useCallback((isCompleted) => {
        setUploadCompleted(isCompleted);
    }, []);

    const getWordCount = (text) => {
        return text
            .trim()
            .split(/\s+/)
            .filter((word) => word.length > 0).length;
    };

    return (
        <FormControl fullWidth error={error} sx={{ mt: 2 }}>
            <Box marginBottom={0.5}>
                <StyledTabs
                    value={tabValue}
                    onChange={handleTabChange}
                    aria-label='text field tabs'
                    variant='fullWidth'
                >
                    <StyledTab label={<span style={{ fontSize: '1.1rem' }}>{tabName}</span>} />
                    <StyledTab label={<span style={{ fontSize: '1.1rem' }}>Upload File</span>} />
                </StyledTabs>
            </Box>
            {tabValue === 0 && (
                <OutlinedInput
                    id={id}
                    placeholder='Please enter text'
                    multiline
                    rows={19}
                    value={value}
                    onChange={onChange}
                    inputProps={{ maxLength: 50000 }}
                    sx={{
                        height: '400px',
                        overflowY: 'auto',
                        alignItems: 'start',
                        '& .MuiInputBase-input': {
                            height: '100%',
                            padding: '1px',
                            textAlign: 'left',
                            lineHeight: 'normal',
                        },
                    }}
                />
            )}

            {tabValue === 1 && (
                <UploadDoc
                    CurrentScan={CurrentScan}
                    onFileUploaded={handleFileUpload}
                    switchToTextTab={switchToTextTab}
                    uploadComplete={uploadCompleted}
                    onUploadComplete={onUploadComplete}
                />
            )}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderColor: 'divider',
                    paddingTop: 0.2,
                    marginTop: 1,
                }}
            >
                <Box
                    sx={{
                        border: '2px solid rgba(31, 38, 65, 0.7)',
                        borderRadius: '16px',
                        padding: '6px 12px',
                    }}
                >
                    <Typography variant='body3'>Words: {getWordCount(value)}</Typography>
                </Box>
                <Button
                    onClick={handleClearText}
                    variant='contained'
                    sx={{
                        color: 'black',
                        backgroundColor: 'rgb(48, 188, 237)',
                        boxShadow:
                            '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
                        '&:hover': {
                            boxShadow:
                                '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
                        },
                    }}
                    startIcon={<ReplayIcon />}
                >
                    Clear
                </Button>
            </Box>
        </FormControl>
    );
};

export default TextFieldToCompare;
